import { useTranslation } from 'react-i18next';

import { useJobChecker, useGenerateFile } from 'cliOld/hooks';
import { ApiStatuses, NotificationPosition } from 'coreOld/enums';
import { useNotification } from 'coreOld/hooks/useNotification';

interface IExportHandlerOptions {
  exportInProgressMessage?: string;
  exportSuccessMessage?: string;
  exportErrorMessage?: string;
}

export const useExportHandler = () => {
  const { t } = useTranslation();
  const { showNotification } = useNotification();
  const { checkJobStatus } = useJobChecker();
  const { onGenerateFileFinished, onGenerateFileStopped } = useGenerateFile();

  const handleExport = async (exportAction, exportPayload, options?: IExportHandlerOptions) => {
    const defaultOptions = (error = null) => ({
      exportInProgressMessage: t('messageGenerateExportFileInProgress'),
      exportErrorMessage: t('errorGenerateExportFilePrefix', {
        errorMessage: error?.message || t('serverError'),
      }),
      ...options,
    });

    showNotification({
      type: ApiStatuses.LOADING,
      message: defaultOptions().exportInProgressMessage,
      position: NotificationPosition.TOP,
    });

    try {
      const data = await exportAction(exportPayload);

      checkJobStatus(
        data,
        (cliJob) => onGenerateFileFinished(cliJob, options),
        (cliJob) => onGenerateFileStopped(cliJob)
      );
    } catch (error) {
      showNotification({
        type: ApiStatuses.ERROR,
        message: defaultOptions(error).exportErrorMessage,
        position: NotificationPosition.TOP,
      });
    }
  };

  return {
    handleExport,
  };
};
